function validateMobile(rule: { message: string }, value: string, callback: (error?: Error) => void) {
  if (!value) {
    callback();
  } else if (!/^1[3-9][0-9]\d{8}$/.test(value)) {
    callback(new Error(rule.message || '字段必须是有效的手机号码'));
  } else {
    callback();
  }
}

export default validateMobile;
